import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { Tooltip } from 'bootstrap';

const DispositionBreakdown = () => {
    const { state } = useContext(SmartContext);
    const dispositions = state.data.dispositions;

    const items = [
        { label: 'Successful', value: dispositions.successful, colorClass: 'bg-success' },
        { label: 'Follow Up', value: dispositions.followUp, colorClass: 'bg-warning' },
        { label: 'Closed', value: dispositions.closed, colorClass: 'bg-danger' },
        { label: 'Other', value: dispositions.other, colorClass: 'bg-secondary' },
    ];

    const total = items.reduce((sum, item) => sum + (parseInt(item.value) || 0), 0);

    useEffect(() => {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    return (
        <div className="col-12">
            <div className="bg-white p-4 custom-shadow h-100 radius-6">
                <h5 className="col font-18 font-600 mb-2">Disposition Breakdown</h5>
                {total > 0 ? (
                    <div
                        className="progress height-20 rounded-pill"
                        role="progressbar"
                        aria-label="Disposition breakdown"
                        aria-valuenow={total}
                        aria-valuemin={0}
                        aria-valuemax={100}>
                        {items.map((item, index) => {
                            const widthPercent = (item.value / total) * 100;
                            return widthPercent > 0 ? (
                                <div
                                    key={index}
                                    className={`progress-bar ${item.colorClass}`}
                                    style={{ width: `${widthPercent}%` }}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title={`${item.label}: ${item.value} (${widthPercent.toFixed(1)}%)`}
                                ></div>
                            ) : null;
                        })}
                    </div>
                ) : (
                    <p className="font-14 text-gray-64">No disposition data available.</p>
                )}

                {total > 0 ? (
                <div className="d-flex flex-wrap align-items-center mt-2 pt-1 gap-2 gap-sm-3 small">
                    {items.map((item, index) => (
                        <div className="d-flex align-items-center" key={index}>
                            <div
                                className={`rounded-circle ${item.colorClass} me-2`}
                                style={{ width: '12px', height: '12px' }}></div>
                            {item.label} ({item.value})
                        </div>
                    ))}
                </div>
                ) : null}
            </div>
        </div>
    );
};

export default DispositionBreakdown;
